var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 136,
    viewBox: "0 0 110 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.0724 42.4506C60.7972 27.6816 72.1809 6.83613 72.6696 5.96966C73.3783 4.73663 73.3759 3.21964 72.6635 1.98873C71.9514 0.757828 70.6371 0 69.2149 0C56.7191 0 46.934 3.55034 40.1316 10.553C28.5081 22.5178 29.0473 41.14 29.2776 49.092C29.3034 49.9731 29.3252 50.7341 29.3252 51.2996C29.3252 57.2039 30.2724 62.6546 31.1083 67.464C31.647 70.5633 32.1121 73.2397 32.195 75.3435C32.2835 77.5965 31.872 78.1123 31.8547 78.1333C31.796 78.2032 31.307 78.463 29.9858 78.463C28.4786 78.463 27.3678 77.9705 26.3831 76.8668C22.5379 72.5549 22.2721 60.7822 23.0073 54.3772C23.1388 53.2477 22.7815 52.1162 22.0253 51.2672C21.2693 50.4183 20.1866 49.9327 19.05 49.9327C8.70525 49.9327 0.975037 66.8498 0.975037 81.9756C0.975037 89.0861 2.40543 96.0513 5.2261 102.678C7.953 109.085 11.8412 114.867 16.784 119.863C27.0767 130.269 40.6483 136 54.9981 136C69.4061 136 82.974 130.35 93.2032 120.092C103.406 109.86 109.025 96.3233 109.025 81.9751C109.025 63.6679 94.7005 48.3082 85.0724 42.4506Z",
    fill: "url(#paint0_linear_4623_2548)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4623_2548",
    x1: 55,
    y1: 0,
    x2: 55,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigFire);
export default __webpack_public_path__ + "static/media/bigFire.6f332668a1867f1923b0f8c7f3b07b98.svg";
export { ForwardRef as ReactComponent };